import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import "@nutui/nutui/dist/style.css";
import { Popup,DatePicker ,Picker } from "@nutui/nutui";

createApp(App).use(router).use(Popup).use(Picker).use(DatePicker).mount('#app')
